<!-- layouts/DefaultLayout.vue -->
<template>
  <div>
    <SideBar />
    <slot />
  </div>
</template>
